enum FourDPPages {
  education = 0,
  quiz,
  results,
  zones,
}

export default FourDPPages;
